import { Button } from 'components/Form/Button/Button';
import { Page } from 'components/Page/Page';
import { useTranslation } from 'react-i18next';
import { useCurrentUser, useRequestPasswordReset } from 'services/repositories/user/user';
import { addNotification, NotificationType } from 'stores/notifications/notifications';
import { SettingsSidebar } from '../SettingsSidebar/SettingsSidebar';
import { Section } from 'components/Display/Section/Section';
import { logError } from 'services/logging/logging';
import { EnvelopeIcon } from '@heroicons/react/24/outline';

export const Password = () => {
  const { t } = useTranslation();
  const { isLoading, data: currentUser } = useCurrentUser();
  const { mutate: requestResetPassword, isLoading: isRequestingPasswordReset } = useRequestPasswordReset();

  const handleRequestResetPassword = () => {
    if (!currentUser) {
      return;
    }
    requestResetPassword(
      { email: currentUser.email },
      {
        onSuccess: () => {
          addNotification(t('auth:resetEmail'));
        },
        onError: (error) => {
          logError(error);
          addNotification(t('common:error.generic'), NotificationType.error);
        },
      },
    );
  };

  return (
    <Page isLoading={isLoading}>
      <Page.Head title={t('common:mainMenu.settings')} />

      <Page.Section leftAside={<SettingsSidebar />}>
        <div className="w-full divide-y divide-gray-200 *:py-6 first:*:pt-0 last:*:pb-0">
          <Section.Horizontal title={t('settings:sidebar.password')} description={t('settings:password.intro')}>
            <Button
              onClick={handleRequestResetPassword}
              disabled={isRequestingPasswordReset}
              loading={isRequestingPasswordReset}
              LeftIcon={EnvelopeIcon}
              variant="secondary"
              analyticsId="account:request_password_reset"
            >
              {t('settings:password.requestReset')}
            </Button>
          </Section.Horizontal>
        </div>
      </Page.Section>
    </Page>
  );
};
